import { PropsWithChildren, useEffect, useRef } from 'react'
import Styles from './Drawer.module.scss'
import { throttle } from 'lodash'
import { WithPadding } from './Types'

interface Props {
  snap: number
  onScrollDown?: () => void
}

export const ScrollableContainer = ({ snap, children, onScrollDown, padding }: PropsWithChildren<Props & WithPadding>) => {
  const viewportHeight = window.innerHeight
  const height = `${viewportHeight * snap - 42}px`
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleScroll = throttle(() => {
      if (!onScrollDown || !containerRef.current) return

      if (containerRef.current.scrollTop > 100) {
        onScrollDown()
      }
    }, 200)

    const container = containerRef.current
    if (container) {
      container.addEventListener('scroll', handleScroll, { passive: true })
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll)
      }
    }
  }, [containerRef, onScrollDown])

  return (
    <div ref={containerRef} className={Styles.container} style={{ height, padding, overflowY: 'scroll' }}>
      {children}
    </div>
  )
}
